import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CaseLawyerHistory } from '../models/cases/caseLawyer';

@Component({
  selector: 'app-case-lawyer-history',
  templateUrl: './case-lawyer-history.component.html',
  styleUrls: ['./case-lawyer-history.component.scss']
})
export class CaseLawyerHistoryComponent implements OnInit {
  lawyers: CaseLawyerHistory[] = [];
  @ViewChild('historyModal') historyModal;
  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(lawyers: CaseLawyerHistory[]) {
    this.lawyers = lawyers;
    this.modalRef = this.modalService.open(this.historyModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

}
